import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { FormShareService } from '../share.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { SignaturesSendService } from '../../../management/signatures/send/send.service';
import { ProjectDataService } from '../../../project/services/project-data.service';
import { ProjectDetailService } from '../../../project/services/project-shared.service';
import { CastProject } from '../../../project/project.functions';


@Injectable()
export class SendCertificationActionHandlerService extends FormActionHandlerService {
  constructor(
    private shareService: FormShareService,
    private swal: SwalService,
    private esignService: SignaturesSendService,
    private projectDataService: ProjectDataService,
    private projectDetailService: ProjectDetailService
  ) {
    super();
  }

  exec(): Promise<any> {
    const that = this;
    return new Promise(resolve => {
      that.swal
        .yesOrNo({
          title: 'Send Certification?',
          text:
            'This will send the certification agreement to the program manager for signature.'
        })
        .then(() => {
          that.esignService
            .sendAgreement(that.shareService.formId)
            .subscribe(() => {
              that.pullProject().then(() => resolve());
            });
        })
        .catch(() => resolve());
    });
  }

  private pullProject(): Promise<void> {
    const projectGuid = this.shareService.formId.projectGuid;
    return new Promise(resolve => {
      this.projectDataService.getProject(projectGuid).subscribe(
        project => {
          if (project) {
            this.projectDetailService.project = CastProject(
              project,
              project.projectInfo.incentiveProgram
            );
          }
          resolve();
        },
        () => resolve()
      );
    });
  }
}
